import { LinkForm } from '../../../components/Links/LinkForm'

export const AddLink = () => {
    return <LinkForm />
}
